import { ApiService } from '../../service/api/ApiService'

const createCompanyBankAccountEndpoint = 'bank/{bankAlias}/company/{companyOkpo}/account'
const companyAllAccountEndpoint = 'company/{companyId}/bank-account'

const createBankAccount = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  context.commit('startSaveBankAccount')

  try {
    const { data } = await ApiService.post(
      createCompanyBankAccountEndpoint.replace('{bankAlias}', formData.bank_alias).replace('{companyOkpo}', formData.company.okpo),
      formData
    )
    context.commit('finishSaveBankAccountSuccess', data)
    context.commit('snackBarModules/showSuccessModal', 'Успешно сохранено', { root: true })
    return data
  } catch (e) {
    const error = ApiService.handleError(e)

    context.commit('finishSaveBankAccountError', error)
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  } finally {
    context.dispatch('fetchAllBankAccount', formData.company)
  }
}

const updateBankAccount = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  context.commit('startSaveBankAccount')

  try {
    const { data } = await ApiService.put(
      createCompanyBankAccountEndpoint.replace('{bankAlias}', formData.bank_alias)
                                      .replace('{companyOkpo}', formData.company.okpo) + `/${formData.id}`,
      formData
    )
    context.commit('finishSaveBankAccountSuccess', data)
    context.commit('snackBarModules/showSuccessModal', 'Успешно сохранено', { root: true })
    return data
  } catch (e) {
    const error = ApiService.handleError(e)

    context.commit('finishSaveBankAccountError', error)
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  } finally {
    context.dispatch('fetchAllBankAccount', formData.company)
  }
}

const fetchAllBankAccount = async (context, { id }) => {
  context.commit('fetchBankAccounts')
  try {
    const { data } = await ApiService.get(companyAllAccountEndpoint.replace('{companyId}', id))
    const response = data.data === undefined ? [] : data.data
    context.commit('fetchBankAccountSuccess', response)
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchBankAccountError', error)
    return null
  }
}

export default {
  createBankAccount, fetchAllBankAccount, updateBankAccount,
}
